import React, { useState } from "react";
import { Shield, Swords } from "lucide-react";
import { teamLogoUrl } from "@/lib/api";

/**
 * Renders the AI-generated team logo if available; otherwise a Lucide-based crest fallback.
 */
export default function TeamLogo({ team, size = 96, className = "" }) {
  const [errored, setErrored] = useState(false);
  const src = teamLogoUrl(team.slug);
  const dim = `${size}px`;

  if (errored) {
    return (
      <div
        className={`relative grid place-items-center select-none ${className}`}
        style={{ width: dim, height: dim }}
        data-testid={`team-logo-fallback-${team.slug}`}
      >
        <div
          className="absolute inset-0"
          style={{
            background: `radial-gradient(circle at 30% 30%, ${team.primary}55, transparent 60%), #0B0C12`,
            border: `1px solid ${team.primary}55`,
          }}
        />
        <Shield
          className="absolute"
          style={{ width: size * 0.85, height: size * 0.85, color: team.primary, opacity: 0.95 }}
          strokeWidth={1.2}
        />
        <div className="relative flex flex-col items-center justify-center">
          <Swords
            style={{ width: size * 0.32, height: size * 0.32, color: team.secondary }}
            strokeWidth={1.8}
          />
          <div
            className="font-display font-bold tracking-widest mt-1"
            style={{ fontSize: size * 0.16, color: team.secondary }}
          >
            {team.abbr}
          </div>
        </div>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={`${team.name} logo`}
      data-testid={`team-logo-${team.slug}`}
      onError={() => setErrored(true)}
      loading="lazy"
      style={{ width: dim, height: dim }}
      className={`object-contain bg-black ${className}`}
    />
  );
}
